export const REQUEST_TYPE_POST = 'POST';

export const GrantType = {
    refresh: 'refresh_token',
    password: 'password',
    credentials: 'client_credentials',
};

export const ErrorMessages = {
    TokenError: {
        ErrorCode: 'TokenError',
        ErrorTitle: 'A Token could not be issued.',
        ErrorMessage: 'The server failed to genereate an authetication token.',
    },
    SchemeError: {
        ErrorCode: 'SchemeError',
        ErrorTitle: 'The requested scheme does not exist.',
        ErrorMessage: '',
    },
    QuestionError: {
        ErrorCode: 'QuestionError',
        ErrorTitle: 'Scheme questions failed to load.',
        ErrorMessage: '',
    },
    SessionError: {
        ErrorCode: 'SessionError',
        ErrorTitle: 'Scheme session is invalid.',
        ErrorMessage: '',
    },
    PolicyError: {
        ErrorCode: 'PolicyError',
        ErrorTitle: 'Policy already created.',
        ErrorMessage: 'A policy has already been created for this session.',
    },
    SessionFormsError: {
        ErrorCode: 'SessionFormsError',
        ErrorTitle: 'Session forms error.',
        ErrorMessage: '',
    },
    SessionQuestionsError: {
        ErrorCode: 'SessionQuestionsError',
        ErrorTitle: 'Session questions error.',
        ErrorMessage: '',
    },
    CreateSessionError: {
        ErrorCode: 'CreateSessionError',
        ErrorTitle: 'An error occured creating the session, please try again.',
        ErrorMessage:
            'An error occured creating the session, please try again.',
    },
    SaveSessionError: {
        ErrorCode: 'SaveSessionError',
        ErrorTitle:
            'An error occured saving session details, please try again.',
        ErrorMessage:
            'An error occured saving session details, please try again.',
    },

    PasswordTooShort: 'Password must be at least 6 characters long.',
    PasswordRequiresDigit: "Passwords must have at least one digit ('0'-'9').",
    PasswordRequiresNonAlphanumeric:
        'Passwords must have at least one non alphanumeric character.',
    PasswordRequiresLower:
        "Passwords must have at least one lowercase ('a'-'z').",
    PasswordRequiresUpper:
        "Passwords must have at least one uppercase ('A'-'Z').",
    PasswordStrength:
        'Password must contain at least one lowercase, one uppercase, one number and one special character.',
    EmailNotFound:
        "Email not found, please check that you've entered it correctly.",
    EmailAlreadyRegistered: 'Email already registered.',
    InvalidActivationCode:
        "Invalid activation code, please check that you've entered it correctly.",
    LoginError:
        "Incorrect email or password, please check that you've entered it correctly.",
    UserNotFound:
        "Incorrect email or password, please check that you've entered it correctly.",
    UnspecifiedError: 'An error occured, please try again.',
    ABNSearchTimeOut: 'ABN Lookup unavailable, please try again later.',
    EmailNotConfirmed:
        'Account requires activation. Please check your email and enter the six digit activation code.',
    BranchInvalidForScheme: 'Login not permitted, please contact your adviser.',
    NoSchemeGuidSet: 'Login not permitted, please contact your adviser.',
};

export const SuccessMessages = {
    LoginSuccessful: 'Welcome back! Please proceed to payment.',
    RegistrationSuccessful:
        'Please check your email and enter the six digit activation code.',
    PasswordResetSuccessful:
        'An email containing instructions to reset your password has been sent.',
    ActivationSuccessful:
        'Thank you! Your account has been activated. Please proceed to payment.',
};
